import { connect } from 'react-redux';
import { IDataStorage } from '../../../core';
import { FxTranslate } from '../../../core/translate';
import { ICardEdit } from '../../../services/operaciones/model/ICardEdit';
import { Secciones } from '../index.service';
import styles from './index.module.scss';
import { Forms } from '../..';

export type IProps = {
  storage: IDataStorage;
  t: FxTranslate;

  data?: ICardEdit | null | undefined;

  onUpdateFields: (updates: { field: string, value: any }[]) => void;
}

function CardSeccionDevoluciones({ storage, t,
  data,
  onUpdateFields
} : IProps) {
  const onUpdateField = (field: string, value: any) => onUpdateFields([ { field, value }]);

  return <div className={styles["card-seccion-content"]}>
    <div className={styles["card-seccion-title"]}>{t(`Menu.${Secciones.Devoluciones}`)}</div>
  
    <div className='p-grid'>
        <div className={"p-col-12 p-p-2"}>
          <Forms.InputArea 
            title={t("Seccion.Field.operacion.motivoDevolucion")}
            className={styles["fix-form-component"]}
            value={data?.operacion?.motivodevolucion}
            onChange={(v,e) => onUpdateField('operacion.motivodevolucion', v)}
            onlyBlurEvent
            height={75}
          />
        </div>

      <div className='p-col-12 p-lg-6 p-p-2'>
        <Forms.Input 
          title={t("Seccion.Field.operacionfacturacion.notacreditoNumero")}
          className={styles["fix-form-component"]}
          value={data?.operacionfacturacion?.notacreditonumero}
          onChange={(v,e) => onUpdateField('operacionfacturacion.notacreditoNumero', v)}
        />
      </div>
      <div className='p-col-12 p-lg-6 p-p-2'>
        <Forms.Calendar 
          title={t("Seccion.Field.operacionfacturacion.notacreditoFecha")}
          className={styles["fix-form-component"]}
          value={data?.operacionfacturacion?.notacreditofecha ? new Date(data?.operacionfacturacion?.notacreditofecha) : undefined}
          onChange={(v,e) => onUpdateField('operacionfacturacion.notacreditoFecha', v)}
        />
      </div>
      <div className='p-col-12 p-lg-12 p-p-2'>
        <Forms.UploadSingleFile 
          title={t("Seccion.Field.operacionfacturacion.notacreditoArchivo")}
          className={styles["fix-form-component"]}
          hideDelete
          value={data?.operacionfacturacion?.notacreditoArchivoDTO}
          onChange={(v,e) => onUpdateField('operacionfacturacion.notacreditoArchivoDTO', v)}
        />
      </div>
      
      <div className='p-col-12 p-lg-6 p-p-2'>
        <Forms.Input 
          title={t("Seccion.Field.operacionfacturacion.devolucionTransaccionNumero")}
          className={styles["fix-form-component"]}
          value={data?.operacionfacturacion?.devoluciontransaccionnumero}
          onChange={(v,e) => onUpdateField('operacionfacturacion.devolucionTransaccionNumero', v)}
        />
      </div>
      <div className='p-col-12 p-lg-6 p-p-2'>
        <Forms.Calendar 
          title={t("Seccion.Field.operacionfacturacion.devolucionTransaccionFecha")}
          className={styles["fix-form-component"]}
          value={data?.operacionfacturacion?.devoluciontransaccionfecha ? new Date(data?.operacionfacturacion?.devoluciontransaccionfecha) : undefined}
          onChange={(v,e) => onUpdateField('operacionfacturacion.devolucionTransaccionFecha', v)}
        />
      </div>

    </div>
  </div>;
}
export default connect((s:any) => ({ storage:s.main }))(CardSeccionDevoluciones);
